/*COMMON*/
export const BEGIN_API_CALL = "BEGIN_API_CALL"; 
export const BEGIN_API_ERROR = "BEGIN_API_ERROR"; 
export const BEGIN_API_UNAUTHORISED = "BEGIN_API_UNAUTHORISED";
export const COOKIES_ALLOW = "COOKIES_ALLOW";
/*AUTH*/
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
/*USERS*/
export const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const DELETE_USER = "DELETE_USER";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const UPDATE_USER_PREFERREDMEASUREMENTS = "UPDATE_USER_PREFERREDMEASUREMENTS";
export const LOAD_USER_TIMELINE_SUCCESS = "LOAD_USER_TIMELINE_SUCCESS";
export const LOAD_NETWORK_FOLLOWERS_SUCCESS = "LOAD_NETWORK_FOLLOWERS_SUCCESS";
export const LOAD_NETWORK_FOLLOWING_SUCCESS = "LOAD_NETWORK_FOLLOWING_SUCCESS";
export const LOAD_USERS_SEARCH_SUCCESS = "LOAD_USERS_SEARCH_SUCCESS";
export const UPDATE_USERNETWORK_SEARCHCRITERIA = "UPDATE_USERNETWORK_SEARCHCRITERIA";
/*NOTIFICATIONS*/
export const LOAD_USER_NOTIFICATIONS = "LOAD_USER_NOTIFICATIONS";
export const UPDATE_NOTIFICATIONS_VIEWED = "UPDATE_NOTIFICATIONS_VIEWED";
export const UPDATE_NOTIFICATION_OPENED = "UPDATE_NOTIFICATION_OPENED";
/*RIDER NETWORK*/
export const NETWORK_FOLLOW_RIDER = "NETWORK_FOLLOW_RIDER";
export const NETWORK_UNFOLLOW_RIDER = "NETWORK_UNFOLLOW_RIDER";
export const NETWORK_REMOVE_FOLLOWING_RIDER = "NETWORK_REMOVE_FOLLOWING_RIDER";
export const NETWORK_BLOCK_RIDER = "NETWORK_BLOCK_RIDER";
export const NETWORK_UNBLOCK_RIDER = "NETWORK_UNBLOCK_RIDER";
export const NETWORK_REQUEST_FOLLOW_RIDER = "NETWORK_REQUEST_FOLLOW_RIDER";
export const NETWORK_APPROVE_FOLLOWER_RIDER = "NETWORK_APPROVE_FOLLOWER_RIDER";
export const NETWORK_REJECT_FOLLOWER_RIDER = "NETWORK_REJECT_FOLLOWER_RIDER";
export const NETWORK_FOLLOWER_RIDER_REQUEST = "NETWORK_FOLLOWER_RIDER_REQUEST"
/*GROUPS*/
export const CREATE_GROUP = "CREATE_GROUP";
export const LOAD_USER_GROUPS = "LOAD_USER_GROUPS";
export const LOAD_GROUPS = "LOAD_GROUPS";
export const LOAD_GROUP = "LOAD_GROUP";
export const EDIT_GROUP = "EDIT_GROUP";
export const ARCHIVE_GROUP = "ARCHIVE_GROUP";
export const REACTIVATE_GROUP = "REACTIVATE_GROUP";
export const UPDATE_GROUP_AVATAR = "UPDATE_GROUP_AVATAR";
export const UPDATE_GROUP_BANNER = "UPDATE_GROUP_BANNER";
export const ADD_USER_GROUP = "ADD_USER_GROUP";
export const REMOVE_USER_GROUP = "REMOVE_USER_GROUP";
export const MAKE_USER_ADMIN_GROUP = "MAKE_USER_ADMIN_GROUP";
export const REVOKE_USER_ADMIN_GROUP = "REVOKE_USER_ADMIN_GROUP";
export const REQUEST_MEMBERSHIP_GROUP = "REQUEST_MEMBERSHIP_GROUP";
export const CONFIRM_MEMBERSHIP_GROUP = "CONFIRM_MEMBERSHIP_GROUP";
export const REJECT_MEMBERSHIP_GROUP = "REJECT_MEMBERSHIP_GROUP";
export const MEMBERSHIP_REJECTION_CLEARED = "MEMBERSHIP_REJECTION_CLEARED";
export const MEMBERSHIP_REJECTION_OVERTURNED = "MEMBERSHIP_REJECTION_OVERTURNED";
export const RESET_GROUPS = "RESET_GROUPS";
export const GROUP_INVITATION_LOADED = "GROUP_INVITATION_LOADED";
export const GROUP_INVITATION_ARCHIVED = "GROUP_INVITATION_ARCHIVED";
/*EVENTS*/
export const LOAD_GROUP_EVENTS = "LOAD_GROUP_EVENTS"; 
export const LOAD_USER_EVENTS = "LOAD_USER_EVENTS"; 
export const LOAD_EVENT = "LOAD_EVENT"; 
export const CREATE_EVENT = "CREATE_EVENT"; 
export const EDIT_EVENT = "EDIT_EVENT"; 
export const EVENT_USER_PARTICIPATION_UPDATE = "EVENT_USER_PARTICIPATION_UPDATE"; 
export const CANCEL_EVENT = "CANCEL_EVENT"; 
export const DELETE_EVENT = "DELETE_EVENT"; 
/*ROUTES*/
export const LOAD_ROUTES_SUCCESS = "LOAD_ROUTES_SUCCESS";
export const LOAD_ROUTE_SUCCESS = "LOAD_ROUTE_SUCCESS";
export const UPDATE_ROUTE_SUCCESS = "UPDATE_ROUTE_SUCCESS"; 
export const CREATE_ROUTE_SUCCESS = "CREATE_ROUTE_SUCCESS";
export const DELETE_ROUTE = "DELETE_ROUTE"; 
export const ADD_BOOKMARK_OPTIMISTIC = "ADD_BOOKMARK_OPTIMISTIC"; 
export const REMOVE_BOOKMARK_OPTIMISTIC = "REMOVE_BOOKMARK_OPTIMISTIC";
export const CLEAR_ROUTE = "CLEAR_ROUTE";
export const SHARE_ROUTE = "SHARE_ROUTE"; 
export const REMOVE_ROUTE_SHARE_OPTIMISTIC = "REMOVE_ROUTE_SHARE_OPTIMISTIC";
export const REACT_ROUTE = "REACT_ROUTE";
export const UNREACT_ROUTE = "UNREACT_ROUTE"; 
export const CHANGE_REACTION_ROUTE = "CHANGE_REACTION_ROUTE";
/*POSTCOMMENTS*/
export const LOAD_USER_POSTS = "LOAD_USER_POSTS";
export const LOAD_GROUP_POSTS = "LOAD_GROUP_POSTS";
export const LOAD_EVENT_POSTS = "LOAD_EVENT_POSTS";
export const LOAD_POST_COMMENTS = "LOAD_POST_COMMENTS";
export const LOAD_NEWS_POSTS = "LOAD_NEWS_POSTS";
export const LOAD_POST = "LOAD_POST";
export const ADD_POST = "ADD_POST";
export const EDIT_POST = "EDIT_POST";
export const DELETE_POST = "DELETE_POST";
export const ADD_COMMENT = "ADD_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const DELETE_POST_IMAGE = "DELETE_POST_IMAGE";
export const DELETE_COMMENT_IMAGE = "DELETE_COMMENT_IMAGE";
export const REACT_POST = "REACT_POST"; 
export const UNREACT_POST = "UNREACT_POST";
export const CHANGE_REACTION_POST = "CHANGE_REACTION_POST";
/*NAV*/
export const NAVITEMS_SET = "NAVITEMS_SET";
/*SETTINGS*/
export const UPDATE_SETTINGS_GENERAL_SUCCESS = "UPDATE_SETTINGS_GENERAL_SUCCESS";
export const UPDATE_SETTINGS_SITE_SUCCESS = "UPDATE_SETTINGS_SITE_SUCCESS";
export const UPDATE_SETTINGS_PASSWORD_SUCCESS = "UPDATE_SETTINGS_PASSWORD_SUCCESS";
export const UPDATE_SETTINGS_AVATAR_SUCCESS = "UPDATE_SETTINGS_AVATAR_SUCCESS";
export const UPDATE_AVATAR_VERSION = "UPDATE_AVATAR_VERSION"; 
export const UPDATE_SETTINGS_BANNER_SUCCESS = "UPDATE_SETTINGS_BANNER_SUCCESS";
export const UPDATE_BANNER_VERSION = "UPDATE_BANNER_VERSION"; 
export const LOAD_SETTINGS_SUCCESS = "LOAD_SETTINGS_SUCCESS";
/*ROUTE SEARCH*/
export const UPDATE_MAP_SEARCHCRITERIA = "UPDATE_MAP_SEARCHCRITERIA";
export const UPDATE_ROUTE_SEARCHCRITERIA = "UPDATE_ROUTE_SEARCHCRITERIA";
export const LOAD_ROUTES_SEARCH_SUCCESS = "LOAD_ROUTES_SEARCH_SUCCESS";
export const LOAD_ROUTES_MYROUTES_SUCCESS = "LOAD_ROUTES_MYROUTES_SUCCESS";
export const LOAD_ROUTES_BOOKMARKS_SUCCESS = "LOAD_ROUTES_BOOKMARKS_SUCCESS";
/*ROUTE CREATOR STATE*/
export const UPDATE_DRAFTROUTE_MAPTYPE = "UPDATE_DRAFTROUTE_MAPTYPE"
export const UPDATE_DRAFTROUTE_ZOOM = "UPDATE_DRAFTROUTE_ZOOM";
export const UPDATE_DRAFTROUTE_CENTRE = "UPDATE_DRAFTROUTE_CENTRE";
export const UPDATE_DRAFTROUTE_CREATEMODE = "UPDATE_DRAFTROUTE_CREATEMODE";
export const UPDATE_DRAFTROUTE_PLOTMODE = "UPDATE_DRAFTROUTE_PLOTMODE";
export const UPDATE_DRAFTROUTE_AUTOMODE = "UPDATE_DRAFTROUTE_AUTOMODE";
export const SET_RECENTREONLOAD = "SET_RECENTREONLOAD";
export const CLEAR_DRAFTROUTE_STATE = "CLEAR_DRAFTROUTE_STATE";
export const SET_DRAFTROUTE_EDIT_ID = "SET_DRAFTROUTE_EDIT_ID";
export const CLEAR_DRAFTROUTE_EDIT_ID = "CLEAR_DRAFTROUTE_EDIT_ID"; 
/*ROUTE CREATOR DRAFT ROUTE*/
export const ADD_DRAFTROUTE_POINTS = "ADD_DRAFTROUTE_POINTS";
export const DELETE_DRAFTROUTE_POINT = "DELETE_DRAFTROUTE_POINT";
export const MOVE_DRAFTROUTE_POINT = "MOVE_DRAFTROUTE_POINT";
export const INSERT_DRAFTROUTE_POINT = "INSERT_DRAFTROUTE_POINT";
export const SAVE_DRAFTROUTE = "SAVE_DRAFTROUTE";
export const CLEAR_DRAFTROUTE = "CLEAR_DRAFTROUTE";







// WEBPACK FOOTER //
// ./src/redux/actions/actionTypes.js